define('lib/ImageFallback',[],function () {
    'use strict';

    /**
     * Fallback images for <img data-fallback-src="...">.
     *
     * Replaces the inline onerror="this.src='...'" attributes the themes used to carry:
     * csp_strict_inline swaps 'unsafe-inline' for a nonce in script-src, and a nonce can only
     * ever apply to a <script> element -- never to an event-handler attribute, which needs
     * 'unsafe-hashes'. So every one of those handlers threw a CSP violation the moment an image
     * actually failed (reported live as intermittent console errors while navigating between
     * booking-page sections, SCP Full Round 3).
     *
     * 'error' does not bubble, so this listens in the capture phase on the document: one
     * listener covers every image on the page, including the ones Marionette renders later.
     */
    document.addEventListener('error', function (event) {
        var img = event.target;

        if (!img || img.tagName !== 'IMG') {
            return;
        }

        var fallback = img.getAttribute('data-fallback-src');

        // data-fallback-applied guards against an endless loop if the fallback itself 404s.
        if (!fallback || img.getAttribute('data-fallback-applied')) {
            return;
        }

        img.setAttribute('data-fallback-applied', '1');
        img.src = fallback;
    }, true);
});

